import { en } from './en';

export const it: Record<string, string> = {
  'delivery.title': "Dove dobbiamo consegnare il tuo ordine?",
  'delivery.beforeSignup': "Verifica la disponibilità della consegna prima di inserire i tuoi dati personali.",
  'delivery.country': "Paese di consegna",
  'delivery.choose': "Scegli il paese di consegna",
  'delivery.availableTo': "Consegna in:",
  'delivery.blocked': "Alcuni articoli non possono essere consegnati nel paese selezionato. Il carrello è stato conservato. Scegli un altro paese di consegna o rimuovi gli articoli non disponibili.",
  'delivery.backToCart': "Torna al carrello",
  'delivery.updateAddress': "Modifica l’indirizzo di consegna",
  'delivery.checkFailed': "Non è stato possibile verificare la disponibilità della consegna. Il carrello è stato conservato. Riprova.",
  'delivery.retry': "Riprova",
  'delivery.checking': "Verifica della disponibilità della consegna…",
  ...en,
  'cart.adding': 'Aggiunta in corso...',
  'cart.added': 'Aggiunto',
  'cart.addSuccess': 'Prodotto aggiunto al carrello',
  'cart.addFail': 'Impossibile aggiungere il prodotto: {error}',
  'title.cart': 'Carrello',
  'title.catalog': 'Catalogo',
  'title.checkout': 'Pagamento',
  'title.signup': 'Registrati',
  'title.tickets': 'Assistenza',
  'title.discounts': 'Il tuo sconto personale',
  'auth.login': 'Accedi',
  'auth.loginModal.remindPassword': 'Hai dimenticato la password?',
  'auth.logout': 'Esci',
  'auth.signup': 'Registrati',
  'auth.myAccount': 'Il mio account',
  'auth.orders': 'I miei ordini',
  'auth.discount': 'Il tuo sconto personale!',
  'discounts.title': 'Il tuo sconto personale',
  'discounts.description': 'Questo sconto viene applicato automaticamente a tutti i tuoi ordini.',
  'auth.bonusAccount': 'Il tuo conto bonus',
  'auth.referral': 'Programma referral',
  'auth.subscriptions': 'Abbonamenti',
  'title.subscriptions': 'Abbonamenti',
  'subs.loading': 'Caricamento...',
  'subs.loginRequired': 'Accedi per gestire gli abbonamenti.',
  'subs.empty': 'Nessuna newsletter disponibile.',
  'subs.instruction': 'Seleziona le newsletter a cui iscriverti o disiscriverti',
  'subs.list.1.name': 'Sconti sui prodotti',
  'subs.list.1.descr': 'Sconti sui prodotti di tuo interesse. Frequenza – mensile',
  'subs.list.2.name': 'Sconti compleanno',
  'subs.list.2.descr': 'E-mail di compleanno con regalo. Frequenza – annuale',
  'subs.list.3.name': 'Promemoria rifornimento',
  'subs.list.3.descr': 'Notifica di rifornimento. Frequenza – ogni 2–3 mesi',
  'subs.list.4.name': 'Novità del negozio',
  'subs.list.4.descr': 'Frequenza – raramente',
  'subs.success': 'Abbonamenti aggiornati',
  'subs.failed': 'Aggiornamento non riuscito.',
  'subs.updating': 'Aggiornamento...',
  'subs.update': 'Aggiorna',
  'inline.loginLink': 'accedi',
  'inline.loginRequiredPrefix': 'Per favore ',
  'inline.loginRequiredSuffix': ' per visualizzare questa pagina.',
  'inline.subscriptionsAuthRedirect':
    'Gli abbonamenti alla newsletter sono disponibili solo per i clienti registrati. Accedi per continuare.',
  'subscribe.title': 'Iscriviti alle offerte',
  'subscribe.subtitle': 'Ricevi sconti esclusivi e promemoria sugli ordini',
  'subscribe.cta': 'Iscriviti',
  'subscribe.emailLabel': 'E-mail',
  'subscribe.emailPlaceholder': 'tu@email.it',
  'subscribe.phoneLabel': 'Telefono',
  'subscribe.phonePlaceholder': '+39 300 000 0000',
  'subscribe.consentLabel': 'Accetto di ricevere e-mail promozionali e promemoria sugli ordini',
  'subscribe.consentRequired': 'Accetta di ricevere e-mail',
  'subscribe.invalidEmail': 'Inserisci un indirizzo e-mail valido',
  'subscribe.success': 'Grazie! Sei iscritto.',
  'auth.tickets': 'Assistenza',
  'auth.deleteAccount': 'Elimina account',
  'cartWidget.cart': 'Carrello',
  'cartWidget.viewCart': 'VEDI CARRELLO',
  'cartWidget.shoppingCart': 'Carrello',
  'cartWidget.items': 'articoli',
  'title.checkoutQnr': 'Questionario medico',
  'title.checkoutConfirm': 'Conferma ordine',
  'cartPage.empty': 'Il tuo carrello è vuoto',
  'cartPage.product': 'Prodotto',
  'cartPage.qty': 'Qtà',
  'cartPage.price': 'Prezzo',
  'cartPage.lineTotal': 'Totale',
  'cartPage.loading': 'Caricamento carrello...',
  'cartPage.startShopping': 'Inizia gli acquisti',
  'cartPage.recalculate': 'Ricalcola',
  'cartPage.remove': 'Rimuovi',
  'cartPage.free': 'Gratis',
  'cartPage.quickNotes': 'Note rapide:',
  'cartPage.note1': '1. L assicurazione spedizione garantisce rimborso o nuova spedizione.',
  'cartPage.note2': '2. Il pagamento in Bitcoin offre il 10% di sconto.',
  'cartPage.note3': '3. Inserisci un coupon di sconto valido qui sotto.',
  'cartPage.note4': '4. Alcuni sconti si attivano dopo la scelta del pagamento.',
  'cartPage.couponPlaceholder': 'Inserisci un coupon qui',
  'cartPage.couponLabel': 'Codice coupon',
  'cartPage.couponSubmit': 'Applica',
  'cartPage.couponInvalid': 'Il coupon non e valido o e scaduto.',
  'cartPage.couponSuccess': 'Il coupon e stato aggiunto con successo.',
  'cartPage.couponNotApplied': 'Il coupon non e stato applicato. Non e valido, e limitato al metodo di pagamento selezionato o non soddisfa i requisiti della promozione.',
  'cartPage.couponCleared': 'Il coupon e stato rimosso.',
  'cartPage.itemRemoved': 'Articolo rimosso dal carrello.',
  'cartPage.removeFailed': 'Impossibile rimuovere l articolo.',
  'cartPage.updateQtyFailed': 'Impossibile aggiornare la quantità.',
  'cartPage.qtyDecrease': 'Diminuisci quantità',
  'cartPage.qtyIncrease': 'Aumenta quantità',
  'cartPage.maxPillsHint': 'Max {pills} compresse ({packs} confezioni)',
  'cartPage.deliveryMethod': 'Metodo di consegna:',
  'cartPage.standard': 'Standard',
  'cartPage.subtotal': 'Subtotale:',
  'cartPage.personalDiscount': 'Sconto personale:',
  'cartPage.bonusDiscount': 'Sconto bonus:',
  'cartPage.discountCoupon': 'Coupon sconto:',
  'cartPage.clearCoupon': 'Rimuovi coupon',
  'cartPage.shippingCost': 'Costo di spedizione:',
  'cartPage.discounted': 'scontato',
  'cartPage.freeShipping': 'spedizione gratuita',
  'cartPage.shippingInsurance': 'Assicurazione spedizione:',
  'cartPage.backToShopping': 'Torna agli acquisti',
  'shippingMethod.airmail_service': 'Servizio posta aerea',
  'cartPage.total': 'Totale:',
  'cartPage.checkout': 'Pagamento',
  'stepper.cart': 'Carrello',
  'stepper.payment': 'Pagamento',
  'stepper.medical': 'Medico',
  'stepper.confirm': 'Conferma',
  'miniCart.subtotal': 'Subtotale:',
  'miniCart.personalDiscount': 'Sconto personale:',
  'miniCart.bonusDiscount': 'Sconto bonus:',
  'miniCart.discountCoupon': 'Coupon sconto:',
  'miniCart.shippingCost': 'Costo di spedizione:',
  'miniCart.freeShipping': 'spedizione gratuita',
  'miniCart.shippingInsurance': 'Assicurazione spedizione:',
  'miniCart.total': 'Totale:',
  'miniCart.editCart': 'Modifica carrello',
  'checkout.continue': 'Continua',
  'confirm.title': 'Conferma ordine',
  'confirm.placeOrder': 'Invia ordine',
  'qnr.title': 'Questionario medico',
  'confirm.retentionConsent': 'Acconsento a ricevere e-mail promozionali e promemoria sui miei ordini',
  'profile.updateProfile': 'Aggiorna profilo',
  'telegram.title': 'Notifiche Telegram',
  'telegram.hint': 'Collega Telegram per ricevere aggiornamenti sugli ordini, avvisi di tracciamento e chat di supporto sul telefono.',
  'telegram.orderFcTitle': 'Conferma il tuo ordine via Telegram',
  'telegram.orderFcIntro': 'Questo ordine richiede una rapida conferma dei tuoi dati prima di poter inviare le istruzioni di pagamento.',
  'telegram.orderFcFastest': 'Opzione più rapida: collega Telegram qui sotto. Dopo l’ordine, il bot invierà una richiesta di conferma.',
  'telegram.orderFcAlternatively': 'In alternativa: conferma per telefono oppure',
  'telegram.liveChat': 'chat live',
  'telegram.orderFcReady': 'Possiamo inviare la richiesta di conferma al tuo Telegram. Controlla la chat del bot.',
  'telegram.orderInfoTitle': 'Ricevi aggiornamenti su Telegram',
  'telegram.orderInfoIntro': 'Collega il nostro bot di supporto per:',
  'telegram.orderInfoItem1': 'Stato dell’ordine e aggiornamenti di spedizione',
  'telegram.orderInfoItem2': 'Scansioni di tracciamento e avvisi di consegna',
  'telegram.orderInfoItem3': 'Promemoria di pagamento quando necessario',
  'telegram.orderInfoItem4': 'Chat diretta con il supporto dal telefono',
  'telegram.statusLoading': 'Verifica connessione Telegram…',
  'telegram.unavailable': 'La connessione Telegram non è disponibile al momento.',
  'telegram.connected': 'Telegram collegato',
  'telegram.connectedAt': 'Collegato',
  'telegram.boundFrom': 'Collegato da',
  'telegram.connect': 'Collega Telegram',
  'telegram.connecting': 'Connessione…',
  'telegram.linkReady': 'Apri Telegram e tocca Start per completare il collegamento dell’account.',
  'telegram.openTelegram': 'Apri Telegram',
  'telegram.copyLink': 'Copia link',
  'telegram.copied': 'Copiato',
  'telegram.expiresMinutes': 'Il link scade tra circa {minutes} minuti.',
  'telegram.notificationsTitle': 'Preferenze notifiche',
  'telegram.notificationsHint': 'La conferma ordine e la chat di supporto funzionano sempre. Scegli gli avvisi opzionali qui sotto.',
  'telegram.notificationsSaving': 'Salvataggio…',
  'telegram.notificationsSaveError': 'Impossibile salvare le impostazioni di notifica.',
  'telegram.disconnect': 'Scollega Telegram',
  'telegram.disconnectConfirm': 'Scollegare Telegram dal tuo account? Puoi ricollegarlo in qualsiasi momento da questa pagina.',
  'telegram.disconnectYes': 'Sì, scollega',
  'telegram.disconnectCancel': 'Annulla',
  'telegram.coupon.checkoutTitle': 'Collega Telegram e risparmia il 20%',
  'telegram.coupon.checkoutBody': 'Collegati ora e applicheremo il 20% a questo ordine.',
  'telegram.coupon.checkoutAction': 'Collega Telegram e applica il 20%',
  'telegram.coupon.applied': 'Telegram collegato — il tuo sconto del 20% è stato applicato.',
  'telegram.coupon.replaceConfirm': 'Sostituisci il coupon attuale e applica il 20%',
  'telegram.coupon.active': 'Coupon Telegram del {percent}% disponibile.',
  'telegram.coupon.redeemed': 'Coupon Telegram utilizzato.',
  'telegram.coupon.expired': 'Il coupon Telegram è scaduto.',
  'telegram.disconnectError': 'Impossibile scollegare Telegram.',
  'telegram.pref.order_status.label': 'Aggiornamenti stato ordine',
  'telegram.pref.order_status.description': 'Elaborazione, annullamento, rifiuto e altri cambi di stato.',
  'telegram.pref.shipped.label': 'Spedizione e numeri di tracciamento',
  'telegram.pref.shipped.description': 'Quando il tuo ordine viene spedito o rispedito con un numero di tracciamento.',
  'telegram.pref.tracking_updates.label': 'Scansioni di tracciamento consegna',
  'telegram.pref.tracking_updates.description': 'Aggiornamenti del corriere, come in transito, in consegna o consegnato.',
  'telegram.pref.payment.label': 'Promemoria di pagamento',
  'telegram.pref.payment.description': 'Istruzioni di pagamento e avvisi di pagamento insufficiente.',
  'telegram.pref.promotions.label': 'Promozioni e offerte',
  'telegram.pref.promotions.description': 'Sconti opzionali e offerte speciali.',
  'signup.createAccount': 'Crea account',
  'login.title': 'Accedi',
  'login.loginLabel': 'Login',
  'login.loginPlaceholder': 'E-mail o nome utente',
  'login.passwordLabel': 'Password',
  'login.loginRequired': 'Il login e obbligatorio',
  'login.passwordRequired': 'La password e obbligatoria',
  'login.invalidCredentials': 'E-mail o password non validi.',
  'login.noAccount': 'Non hai un account?',
  'login.signupLink': 'Registrati',
  'login.submit': 'Accedi',
  'signup.personalInfo': 'Informazioni personali',
  'signup.title': 'Titolo',
  'signup.mr': 'Sig.',
  'signup.mrs': 'Sig.ra',
  'signup.ms': 'Sig.ra',
  'signup.firstName': 'Nome',
  'signup.lastName': 'Cognome',
  'signup.contactInfo': 'Informazioni di contatto',
  'signup.email': 'E-mail',
  'signup.phone': 'Telefono',
  'signup.billingAddress': 'Indirizzo di fatturazione',
  'signup.address': 'Indirizzo',
  'signup.zipcode': 'CAP',
  'signup.city': 'Citta',
  'signup.country': 'Paese',
  'signup.state': 'Provincia',
  'signup.selectCountry': 'Seleziona paese',
  'signup.stateProvince': 'Provincia / Regione',
  'signup.selectState': 'Seleziona provincia',
  'signup.shippingAddress': 'Indirizzo di spedizione',
  'signup.sameAsBilling': 'Uguale all\'indirizzo di fatturazione',
  'signup.privacyInfo': 'Informazioni sulla privacy',
  'signup.password': 'Password',
  'signup.passwordHint': 'Minimo 5 caratteri. Deve essere diversa dal nome utente.',
  'signup.confirmPassword': 'Conferma password',
  'signup.agreeTermsTemplate': 'Accetto i {terms} dell\'azienda.',
  'signup.agreeTermsLink': 'Termini e condizioni',
  'signup.firstNameRequired': 'Il nome e obbligatorio',
  'signup.lastNameRequired': 'Il cognome e obbligatorio',
  'signup.emailRequired': 'L\'e-mail e obbligatoria',
  'signup.emailInvalid': 'Formato e-mail non valido',
  'signup.phoneRequired': 'Il telefono e obbligatorio',
  'signup.addressRequired': 'L\'indirizzo e obbligatorio',
  'signup.zipcodeRequired': 'Il CAP e obbligatorio',
  'signup.cityRequired': 'La citta e obbligatoria',
  'signup.countryRequired': 'Il paese e obbligatorio',
  'signup.passwordRequired': 'La password e obbligatoria',
  'signup.passwordMinLength': 'La password deve contenere almeno 5 caratteri',
  'signup.passwordMismatch': 'Le password non corrispondono',
  'signup.termsRequired': 'Devi accettare i termini e condizioni',
  'signup.failed': 'Registrazione non riuscita',
  'signup.creating': 'Creazione account...',
  'forgotPassword.emailLabel': 'E-mail',
  'forgotPassword.emailPlaceholder': 'tuo@esempio.it',
  'forgotPassword.submit': 'Invia codice',
  'forgotPassword.success': 'Abbiamo inviato un codice di 10 caratteri alla tua e-mail.',
  'forgotPassword.successHint': 'Inserisci il codice nella pagina successiva per impostare una nuova password.',
  'forgotPassword.goToSetPassword': 'Inserisci codice e imposta password',
  'forgotPassword.backToLogin': 'Torna al login',
  'forgotPassword.invalidEmail': 'Inserisci un indirizzo e-mail valido',
  'resetPassword.emailLabel': 'E-mail',
  'resetPassword.resetCodeLabel': 'Codice ricevuto via e-mail',
  'resetPassword.resetCodePlaceholder': '10 caratteri',
  'resetPassword.resetCodeFormat': 'Il codice deve contenere esattamente 10 lettere o numeri',
  'resetPassword.newPasswordLabel': 'Nuova password',
  'resetPassword.confirmLabel': 'Conferma password',
  'resetPassword.passwordPlaceholder': '••••••••',
  'resetPassword.passwordMin': 'La password deve contenere almeno 5 caratteri',
  'resetPassword.passwordMismatch': 'Le password non corrispondono',
  'resetPassword.submit': 'Salva',
  'resetPassword.success': 'Password aggiornata. Ora puoi accedere.',
  'resetPassword.redirectHint': 'Reindirizzamento...',
  'orders.title': 'I miei ordini',
  'tickets.newMessage': 'Messaggio',
  'tickets.newUpload': 'Carica file (PDF, JPG, PNG, TXT)',
  'contact.formTitle': 'Inviaci un messaggio',
  'contact.loginRequired': 'Accedi per inviare un ticket di supporto.',
  'testimonials.customer': 'Cliente',
  'testimonials.loading': 'Caricamento testimonianze...',
  'testimonials.empty': 'Non ci sono ancora testimonianze.',
  'testimonials.loadError': 'Impossibile caricare le testimonianze. Riprova piu tardi.',
  'testimonials.formTitle': 'Lascia una testimonianza',
  'testimonials.namePlaceholder': 'Il tuo nome',
  'testimonials.messagePlaceholder': 'La tua recensione',
  'testimonials.submitting': 'Invio...',
  'testimonials.submit': 'Invia recensione',
  'testimonials.submitError': 'Impossibile inviare la testimonianza.',
  'testimonials.loginRequired': 'Accedi per lasciare una testimonianza.',
  'testimonials.validationName': 'Il nome deve contenere almeno 2 caratteri.',
  'testimonials.validationMessage': 'La recensione deve contenere almeno 6 caratteri.',
  'testimonials.success': 'Grazie per la recensione! Apparira dopo la moderazione.',
  'contact.requestFrom': 'La richiesta verra inviata da',
  'contact.unknownUser': 'Utente autenticato',
  'contact.subject': 'Oggetto',
  'contact.subjectPlaceholder': 'Come possiamo aiutarti?',
  'contact.message': 'Messaggio',
  'contact.messagePlaceholder': 'Descrivi il tuo problema...',
  'contact.send': 'Invia messaggio',
  'contact.ticketsLoginRequired': 'Accedi per visualizzare e inviare ticket di supporto.',
  'chat.online': 'Online',
  'chat.offline': 'Offline',
  'chat.coming_soon': 'La chat live e in fase di configurazione. Per ora usa email o telefono.',
  'chat.offline_message': 'I nostri operatori sono attualmente offline.',
  'chat.leave_message': 'Lascia un messaggio e ti risponderemo.',
  'chat.leave_ticket': 'Lascia un ticket',
  'nav.login': 'Accedi',
  'nav.signup': 'Crea account',
  'miniCart.deliveryMethod': 'Metodo di consegna',
  'month.1': 'Gennaio', 'month.2': 'Febbraio', 'month.3': 'Marzo',
  'month.4': 'Aprile', 'month.5': 'Maggio', 'month.6': 'Giugno',
  'month.7': 'Luglio', 'month.8': 'Agosto', 'month.9': 'Settembre',
  'month.10': 'Ottobre', 'month.11': 'Novembre', 'month.12': 'Dicembre',
  'checkout.accountHint': 'Numero di conto: di solito viene prima del numero dell\'assegno; la posizione varia.',
  'checkout.accountNumber': 'Numero di conto',
  'checkout.authLogin': 'Accedi',
  'checkout.authPrompt': 'Accedi o registrati per continuare con l\'acquisto.',
  'checkout.authSignup': 'Registrati',
  'checkout.backToConfirm': 'Torna alla conferma dell\'ordine',
  'checkout.backToShop': 'Torna al negozio',
  'checkout.bankName': 'Nome della banca',
  'checkout.btcStep1': "Completa l’ordine per aprire la pagina di pagamento.",
  'checkout.btcStep2': "Invia l’importo esatto in BTC all’indirizzo indicato, utilizzando la rete specificata.",
  'checkout.btcStep3': "Paga prima che scadano i dati di pagamento.",
  'checkout.btcOrderNote': "Usa questi dati di pagamento solo per questo ordine. Non è necessaria alcuna conferma telefonica.",
  'checkout.btcHelp': "Come acquistare Bitcoin",
  "checkout.cryptoTitle": "Paga con criptovalute",
  "checkout.cryptoStep1": "Fai clic su Continua.",
  "checkout.cryptoStep2": "Scegli la valuta e la rete nella pagina successiva.",
  "checkout.cryptoStep3": "Segui le istruzioni per completare il pagamento.",
  "checkout.cryptoCoinsLabel": "Valute disponibili",
  "checkout.cryptoCoins": "Ethereum · Litecoin · Bitcoin Cash · Dogecoin · Monero · Tron · XRP · Cardano · TON · BNB",
  "checkout.cryptoNetworks": "Scegli Ethereum (ERC-20), Tron (TRC-20) o BNB Smart Chain (BEP-20).",
  "checkout.cryptoBitcoinTitle": "Vuoi pagare con Bitcoin (BTC)?",
  "checkout.cryptoBitcoinNote": "Seleziona la modalità di pagamento Bitcoin separata al checkout.",
  'checkout.btcTitle': "Paga con Bitcoin",
  'checkout.cartEmpty': 'Il tuo carrello e vuoto.',
  'checkout.ccNumber': 'Numero di carta di credito (senza spazi o trattini)',
  'checkout.ccType': 'Tipo di carta di credito',
  'checkout.checkNumber': 'Numero assegno',
  'checkout.cvv': 'CVV2',
  'checkout.error': 'Si e verificato un errore',
  'checkout.expDate': 'Data di scadenza',
  'checkout.loading': 'Caricamento checkout...',
  'checkout.noPayments': 'Sfortunatamente, non sono disponibili pagamenti per il checkout. Si prega di contattare il reparto vendite o supporto.',
  'checkout.paymentFailed': 'Impossibile impostare il metodo di pagamento',
  'checkout.processing': 'Elaborazione...',
  'checkout.routingHint': 'Numero di routing (codice ABA): solitamente 9 cifre sull\'assegno.',
  'checkout.routingNumber': 'Numero di routing (codice ABA)',
  'checkout.selectPayment': 'Seleziona un metodo di pagamento',
  'contact.email': 'E-mail',
  'contact.hours': 'Orario di lavoro',
  'contact.previewHours': 'Lun-Ven 9:00-18:00',
  'contact.support247': 'Supporto 24/7',
  'contact.live_chat': 'Chatta dal vivo',
  'contact.open_ticket': 'Apri un ticket',
  'contact.phone': 'Telefono',
  'contact.start_chat': 'Avvia la chat',
  'contact.tickets_desc': 'Hai una domanda? Apri un ticket di supporto e ti ricontatteremo.',
  'contact.title': 'Contattaci',
  'contact.unavailable': 'Le informazioni di contatto non sono disponibili.',
  'deleteAccount.attention': 'Attenzione!',
  'deleteAccount.failed': 'Richiesta non riuscita. Per favore riprova.',
  'deleteAccount.password': 'Password',
  'deleteAccount.passwordRequired': 'E richiesta la password.',
  'deleteAccount.reason': 'Motivo',
  'deleteAccount.reasonHint': 'Per favore condividi il motivo della tua partenza. Il tuo feedback ci aiuta a migliorare.',
  'deleteAccount.reasonRequired': 'La ragione e necessaria.',
  'deleteAccount.rule1': 'Non dovresti avere alcun chargeback nella tua cronologia.',
  'deleteAccount.rule2': 'Devono trascorrere almeno 21 giorni dall\'ultimo ordine andato a buon fine.',
  'deleteAccount.rules': 'Regole di cancellazione dell\'account:',
  'deleteAccount.safetyInfo': 'La tua privacy e importante per noi. Puoi eliminare definitivamente il tuo account e la relativa cronologia in qualsiasi momento.',
  'deleteAccount.submit': 'Invia',
  'deleteAccount.success': 'Account eliminato con successo.',
  'deleteAccount.thanks': 'Grazie per aver scelto il nostro servizio.',
  'deleteAccount.warning': 'Se successivamente viene ricevuto uno storno di addebito per qualsiasi ordine, il tuo account potrebbe essere ripristinato per elaborare quel caso. Per domande, contattare l\'assistenza 24 ore su 24, 7 giorni su 7.',
  'profile.address': 'Indirizzo',
  'profile.addressRequired': 'L\'indirizzo e obbligatorio',
  'profile.billingAddress': 'Indirizzo di fatturazione',
  'profile.changePassword': 'Cambiare la password',
  'profile.city': 'Citta',
  'profile.cityRequired': 'La citta e obbligatoria',
  'profile.confirmPassword': 'Conferma password',
  'profile.country': 'Paese',
  'profile.countryRequired': 'Il Paese e obbligatorio',
  'profile.email': 'E-mail',
  'profile.emailInvalid': 'Formato email non valido',
  'profile.emailRequired': 'L\'e-mail e obbligatoria',
  'profile.firstName': 'Nome di battesimo',
  'profile.firstNameRequired': 'Il nome e obbligatorio',
  'profile.lastName': 'Cognome',
  'profile.lastNameRequired': 'Il cognome e obbligatorio',
  'profile.loadFailed': 'Impossibile caricare i dati del profilo',
  'profile.loading': 'Caricamento profilo...',
  'profile.mr': 'Sig.',
  'profile.mrs': 'Sig.ra.',
  'profile.ms': 'Sig.ra',
  'profile.newPassword': 'Nuova password',
  'profile.passwordHint': 'Lascia vuoto se non vuoi cambiare la password.',
  'profile.passwordMinLength': 'La password deve contenere almeno 5 caratteri',
  'profile.passwordMismatch': 'Le password non corrispondono',
  'profile.personalInfo': 'Informazioni personali',
  'profile.phone': 'Telefono',
  'profile.phoneRequired': 'E richiesto il telefono',
  'profile.sameAsBilling': 'Uguale all\'indirizzo di fatturazione',
  'profile.saving': 'Salvataggio...',
  'profile.selectCountry': 'Seleziona Paese',
  'profile.selectState': 'Seleziona Stato',
  'profile.shippingAddress': 'Indirizzo di spedizione',
  'profile.state': 'Stato',
  'profile.stateProvince': 'Stato/Provincia',
  'profile.title': 'Titolo',
  'profile.updateFailed': 'Aggiornamento non riuscito',
  'profile.updateSuccess': 'Profilo aggiornato con successo',
  'profile.zipcode': 'CAP',
  'profile.zipcodeRequired': 'Il codice postale e obbligatorio',
  'select.noResults': 'Nessun risultato trovato',
  'select.placeholder': 'Selezionare...',
  'select.search': 'Ricerca...',
  'tickets.activationFailed': 'Impossibile inviare l\'e-mail di attivazione',
  'tickets.activationSuccess': 'Email di attivazione inviata con successo',
  'tickets.authInstructions': 'Se desideri attivarlo, fai clic sul pulsante in basso e ti invieremo via email le istruzioni.',
  'tickets.authNotActivated': 'Il sistema di ticket non e ancora stato attivato per il tuo account.',
  'tickets.backToTickets': 'Torna ai ticket',
  'tickets.createSuccess': 'Ticket creato con successo',
  'tickets.date': 'Data',
  'tickets.dateLabel': 'Data:',
  'tickets.detailLoading': 'Caricamento ticket...',
  'tickets.empty': 'Nessun ticket trovato al momento. Utilizza \"Apri nuovo ticket\" per porre una domanda',
  'tickets.fileLimit': 'Seleziona fino a 3 file.',
  'tickets.lastReply': 'Ultima risposta',
  'tickets.loading': 'Caricamento ticket...',
  'tickets.loadingMore': 'Caricamento di piu...',
  'tickets.message': 'Messaggio',
  'tickets.newSubject': 'Oggetto',
  'tickets.newTicketTitle': 'Apri nuovo ticket',
  'tickets.noMessages': 'Nessun messaggio trovato.',
  'tickets.messagesHeading': 'Messaggi',
  'tickets.messageFromSupport': 'Supporto',
  'tickets.messageFromYou': 'Tu',
  'tickets.replyHeading': 'Rispondi',
  'tickets.attachFiles': 'Allega file',
  'tickets.filesCount': '{count} file',
  'tickets.notActivated': 'Sistema di ticket non attivato per il tuo account.',
  'tickets.openNew': 'Apri nuovo ticket',
  'tickets.refresh': 'Aggiorna',
  'tickets.resolve': 'Risolvi il ticket',
  'tickets.resolveConfirm': 'Sei sicuro di voler risolvere questo ticket?',
  'tickets.sendActivation': 'Invia e-mail di attivazione',
  'tickets.sendReply': 'Invia risposta',
  'tickets.status': 'Stato',
  'tickets.statusAwaitingAgent': 'Agente in attesa',
  'tickets.statusAwaitingUser': 'In attesa dell\'utente',
  'tickets.statusLabel': 'Stato:',
  'tickets.statusPending': 'In attesa',
  'tickets.statusResolved': 'Risolto',
  'tickets.subject': 'Oggetto',
  'tickets.submitTicket': 'Invia il ticket',
  'tickets.title': 'Ticket di supporto',
  'tickets.uploadFiles': 'Carica file (PDF, JPG, PNG, TXT)',
  'close': 'Chiudi',
  'loading': 'Caricamento...',
  'yes': 'Sì',
  'no': 'No',
  'tickets.unavailable': 'I ticket di supporto sono temporaneamente non disponibili. Riprova più tardi o contatta il supporto via email se urgente.',
  'api.genericError': 'Si è verificato un errore. Riprova più tardi.',
  'api.networkError': 'Servizio temporaneamente non disponibile. Controlla la connessione.',
  'api.error.10503': 'Servizio non disponibile',
  'api.error.40001': 'L\'autenticazione del cliente non è riuscita',
  'api.error.40004': 'La validazione dei dati del cliente non è riuscita',
  'api.error.40008': 'Questo login esiste già',
  'api.error.40009': 'Questa email esiste già',
  'api.error.40021': 'L\'account cliente esiste già',
  'api.error.40022': 'Cliente non trovato',
  'api.error.400014': 'Il coupon non è valido',
  'api.error.50001': 'Il controllo antifrode non è riuscito',
  'api.error.50002': 'L\'account ha ordini aperti e non può essere eliminato.',
  'api.error.60001': 'Questo prodotto non è attualmente disponibile.',
  'geo.soft_notice': 'This product has delivery region limits. Final availability is confirmed after sign-in using your shipping address.',
  'api.error.60101': 'Puoi aggiungere fino a {limit} prodotti diversi per ordine.',
  'api.error.60102': 'La quantità massima per questo prodotto è {limit}.',
  'api.error.60103': 'Il numero massimo di confezioni per questo prodotto è {limit}.',
  'unsubscribe.processing': 'Elaborazione…',
  'unsubscribe.success': 'Sei stato disiscritto dalle e-mail di marketing di {shop_name}.',
  'unsubscribe.shop': 'Negozio',
  'unsubscribe.invalidLink': 'Link non valido o scaduto.',
  'unsubscribe.error': 'Si è verificato un errore.',

  'title.orderReturn': 'Stato del pagamento',
  'orderReturn.successTitle': 'Grazie!',
  'orderReturn.successLead': 'Il tuo pagamento è stato ricevuto.',
  'orderReturn.successHint': 'Ti abbiamo inviato un\'e-mail di conferma. Gli aggiornamenti di spedizione arriveranno a breve.',
  'orderReturn.cancelTitle': 'Pagamento annullato',
  'orderReturn.cancelLead': 'Nessun pagamento è stato addebitato per questo ordine.',
  'orderReturn.cancelHint': 'Dopo il checkout il carrello è vuoto. Usa i dettagli ordine o « Riprova » qui sotto.',
  'orderReturn.failureTitle': 'Pagamento non riuscito',
  'orderReturn.failureLead': 'Non siamo riusciti a completare il pagamento di questo ordine.',
  'orderReturn.failureHint': 'Il carrello è stato svuotato con l\'ordine. Riprova, apri i dettagli o contatta il supporto.',
  'orderReturn.btnDetails': 'Vedi i dettagli dell\'ordine',
  'orderReturn.btnSignIn': 'Accedi per vedere i dettagli',
  'orderReturn.btnContinueShopping': 'Continua lo shopping',
  'orderReturn.btnContactSupport': 'Contatta il supporto',
  'orderReturn.btnTryAgain': 'Riprova',
  'confirm.loadFailed': 'Impossibile caricare i dettagli dell ordine',
  'confirm.shippingAddress': 'Indirizzo di spedizione',
  'confirm.edit': 'Modifica',
  'confirm.paymentMethod': 'Metodo di pagamento',
  'confirm.notSelected': 'Non selezionato',
  'confirm.shippingNote': '*La spedizione US2US richiede in genere 3 giorni lavorativi dopo la spedizione (fino a 5 giorni lavorativi).',
  'confirm.overseasShippingNote': '*La spedizione overseas richiede in genere 14-28 giorni lavorativi per prodotti UE e indiani.',
  'confirm.manufacturerNote': '*Abbiamo diversi produttori per questo prodotto. Se il produttore ordinato è attualmente esaurito, ti contatteremo e offriremo un alternativa.',
  'confirm.agreePolicy': 'Dichiaro di accettare la Politica di rimborso e la Politica sui chargeback',
  'confirm.back': 'Indietro',
  'confirm.placing': 'Invio ordine...',
  'confirm.previewModeNotice': 'Modalità anteprima - gli ordini reali sono disabilitati.',
  'confirm.success': 'Ordine effettuato con successo!',
  'confirm.invalidResponse': 'Risposta ordine non valida',
  'confirm.failed': 'Impossibile effettuare l ordine',
  'qnr.loading': 'Caricamento questionario...',
  'qnr.loadFailed': 'Impossibile caricare il questionario',
  'qnr.retry': 'Riprova',
  'qnr.intro': 'Compila questo modulo per richiedere la prescrizione del farmaco ordinato. Sono le stesse informazioni richieste in una clinica o da un medico.',
  'qnr.general': 'Informazioni generali',
  'qnr.dob': 'Data di nascita del paziente',
  'qnr.day': 'Giorno',
  'qnr.month': 'Mese',
  'qnr.year': 'Anno',
  'qnr.dobRequired': 'La data di nascita è obbligatoria',
  'qnr.gender': 'Genere',
  'qnr.selectPlaceholder': 'Seleziona...',
  'qnr.genderRequired': 'Il genere è obbligatorio',
  'qnr.height': 'Altezza del paziente',
  'qnr.heightRequired': 'L altezza è obbligatoria',
  'qnr.weight': 'Peso del paziente',
  'qnr.weightRequired': 'Il peso è obbligatorio',
  'qnr.medicalHistory': 'Storia medica',
  'qnr.disorderQuestion': 'Qual è il disturbo o reclamo per cui richiedi questo farmaco?',
  'qnr.conditionRequired': 'La condizione medica è obbligatoria',
  'qnr.otherDisease': 'Hai altre malattie, disturbi o problemi medici?',
  'qnr.yesNo': 'Rispondi sì o no',
  'qnr.specifyOther': 'Se sì, specifica',
  'qnr.specifyRequired': 'Specifica altri problemi medici',
  'qnr.confirmations': 'Conferme',
  'qnr.declaration': 'Dichiaro che le informazioni fornite sono complete e senza riserve...',
  'qnr.declarationRequired': 'La dichiarazione è obbligatoria',
  'qnr.responsibility': 'Dichiarazione di responsabilità del cliente',
  'qnr.responsibilityRequired': 'La dichiarazione di responsabilità è obbligatoria',
  'qnr.consent': 'Dichiaro di accettare l Accordo di consenso informato',
  'qnr.consentRequired': 'L accordo di consenso è obbligatorio',
  'qnr.yes': 'Sì',
  'qnr.no': 'No',
  'qnr.back': 'Indietro',
  'qnr.saving': 'Salvataggio...',
  'qnr.continue': 'Continua',
  'qnr.saved': 'Questionario medico salvato',
  'qnr.saveFailed': 'Impossibile salvare il questionario',
  'validate.ccEmpty': 'Il numero della carta non può essere vuoto',
  'validate.ccInvalid': 'Il numero della carta non è valido',
  'validate.ccAmex': 'Il numero della carta Amex deve essere valido',
  'validate.ccMaster': 'Il numero MasterCard deve essere valido',
  'validate.ccVisa': 'Il numero Visa deve essere valido',
  'validate.ccTypeEmpty': 'Il tipo di carta non può essere vuoto',
  'validate.cvvDigits': 'Il CVV2 deve avere 3-4 cifre',
  'validate.cvvEmpty': 'Il CVV2 non può essere vuoto',
  'validate.bankEmpty': 'Il nome della banca non può essere vuoto',
  'validate.bankLength': 'Il nome della banca deve avere da 1 a 32 caratteri',
  'validate.chequeEmpty': 'Il numero assegno non può essere vuoto',
  'validate.chequeDigits': 'Il numero assegno deve contenere solo cifre',
  'validate.chequeLength': 'Il numero assegno deve avere da 1 a 16 caratteri',
  'validate.routingEmpty': 'Il numero di routing non può essere vuoto',
  'validate.routingDigits': 'Il numero di routing deve contenere solo cifre',
  'validate.routingLength': 'Il numero di routing deve avere da 1 a 16 caratteri',
  'validate.accountEmpty': 'Il numero di conto non può essere vuoto',
  'validate.accountDigits': 'Il numero di conto deve contenere solo cifre',
  'validate.accountLength': 'Il numero di conto deve avere da 1 a 16 caratteri',
  'paymentMethod.credit_card_amex': 'Carta di credito (Amex)',
  'paymentMethod.credit_card': 'Carta di credito',
  'paymentMethod.echeque': 'Assegno elettronico',
  'paymentMethod.bitcoin': 'Bitcoin',
  'paymentCard.amex': 'Amex',
  'paymentCard.mc': 'MasterCard',
  'paymentCard.visa': 'Visa',
  'orderSuccess.placedSuccess': 'Il tuo ordine è stato effettuato con successo.',
  'orderSuccess.thanks': 'Grazie! Il tuo ordine è stato effettuato.',
  'orderSuccess.orderId': 'ID ordine:',
  'orderSuccess.description': 'Riceverai una conferma dell ordine via e-mail. Elaboreremo il tuo ordine il prima possibile.',
  'orderSuccess.orderDetails': 'Dettagli ordine',
  'orderSuccess.viewOrders': 'Vedi i miei ordini',
  'orderSuccess.close': 'Torna al negozio',
  'pagination.label': 'Paginazione',
  'pagination.first': 'Prima',
  'pagination.previous': 'Precedente',
  'pagination.next': 'Successivo',
  'pagination.last': 'Ultima',

  // ── OrdersView (list/filter) ──
  'orders.loading': 'Caricamento ordini...',
  'orders.loadFailed': 'Impossibile caricare gli ordini',
  'orders.empty': 'Nessun ordine ancora.',
  'orders.filter': 'Filtro:',
  'orders.allTime': 'Sempre',
  'orders.thisMonth': 'Questo mese',
  'orders.thisWeek': 'Questa settimana',
  'orders.today': 'Oggi',

  // ── BonusAccountPage ──
  'referralProgram.headline': 'Invita un amico: {friend}% per lui, {reward}% per te.',
  'referralProgram.intro': 'Condividi il tuo link personale. Dopo la consegna del suo primo ordine, qui apparirà un coupon separato del {reward}%.',
  'referralProgram.how': 'Il tuo amico riceve il {friend}% sul primo ordine. Tu ricevi dopo la spedizione un coupon del {reward}% valido per {months} mesi.',
  'referralProgram.rulesTitle': 'Regole dei coupon',
  'referralProgram.ruleSeparate': 'Ricevi un coupon separato per ogni nuovo cliente invitato.',
  'referralProgram.ruleOnePerOrder': 'È possibile applicare un solo coupon per ordine.',
  'referralProgram.ruleNoLimit': 'Lo sconto del {reward}% non ha un limite massimo.',
  'referralProgram.couponsTitle': 'I tuoi coupon referral',
  'referralProgram.noCoupons': 'Non hai ancora coupon referral.',
  'referralProgram.apply': 'Applica al carrello',
  'referralProgram.applying': 'Applicazione…',
  'referralProgram.expires': 'Scade',
  'referralProgram.status.active': 'Attivo',
  'referralProgram.status.redeemed': 'Usato',
  'referralProgram.status.expired': 'Scaduto',
  'referralProgram.status.revoked': 'Non disponibile',
  'referralShare.button': 'Condividi',
  'referralShare.signIn': 'Accedi o crea un account per condividere il tuo link referral personale.',
  'referralShare.signInButton': 'Accedi per condividere',
  'referralShare.copied': 'Link referral copiato.',
  'referralShare.failed': 'Impossibile condividere o copiare il link referral.',
  'referralShare.ready': 'Il tuo link è pronto. Tocca Condividi per inviarlo.',
  'referralCoupon.loginRequired': 'Accedi per applicare il coupon di sconto.',
  'referralCoupon.applied': 'Il tuo coupon di sconto del {reward}% è stato applicato.',
  'referralCoupon.appliedGeneric': 'Il tuo coupon di sconto è stato applicato.',
  'referralCoupon.applyFailed': 'Non è stato possibile applicare il coupon. Riprova dal tuo account.',
  'bonus.headline': 'Guadagna bonus a vita con il nostro programma referral',
  'bonus.intro': 'Invita amici e guadagna bonus sui loro acquisti. Puoi usare il saldo bonus per coprire fino al 50% del tuo prossimo ordine.',
  'bonus.howTitle': 'Come funziona?',
  'bonus.howDesc': 'Condividi il tuo link o codice referral personale. Quando un nuovo cliente ordina con esso, ricevi il 15% del valore spedito come credito bonus.',
  'bonus.subsequent': 'Per ogni loro futuro ordine spedito, ricevi un ulteriore 5%.',
  'bonus.friendBenefits': 'Quali vantaggi ha il tuo amico?',
  'bonus.friendDiscount': 'Il tuo amico ottiene il 20% di sconto sul primo ordine usando il tuo link o codice.',
  'bonus.whyGreat': 'Perché è vantaggioso per te:',
  'bonus.benefit1': 'Usa i bonus per coprire fino al 50% del totale ordine.',
  'bonus.benefit2': 'Ricevi una notifica ogni volta che il saldo bonus viene accreditato.',
  'bonus.benefit3': 'Guadagna anche dai sub-referral: 10% dei bonus che il tuo referral diretto riceve.',
  'bonus.startSharing': 'Condividi il tuo link referral e inizia a guadagnare oggi.',
  'bonus.refLinkLabel': 'Il tuo link referral (clicca per copiare)',
  'bonus.copy': 'Copia negli appunti',
  'bonus.copied': 'Copiato',
  'bonus.copyFailed': 'Copia non riuscita',
  'bonus.refCodeIntro': 'In alternativa, puoi condividere il tuo codice univoco, che i tuoi referral possono usare come codice coupon.',
  'bonus.transactions': 'Transazioni conto bonus',
  'bonus.referralTree': 'Albero referral',

  // ── BonusTransactionsPage ──
  'bonusTx.loading': 'Caricamento...',
  'bonusTx.back': 'Indietro',
  'bonusTx.balance': 'Conto bonus:',
  'bonusTx.date': 'Data',
  'bonusTx.addedBonus': 'Bonus aggiunto',
  'bonusTx.usedBonus': 'Bonus usato',
  'bonusTx.type': 'Tipo',
  'bonusTx.empty': 'Non ci sono ancora transazioni nel tuo conto bonus.',
  'bonusTx.typeM': 'Bonus da acquisto referral',
  'bonusTx.typeC': 'Bonus da acquisto sub-referral',
  'bonusTx.typeO': 'Bonus applicato per pagare il tuo ordine',
  'bonusTx.typeOOrder': 'Bonus applicato per pagare il tuo ordine n. {orderId}',
  'bonusTx.typeP': 'Regalo',
  'bonusTx.typeW': 'Prelievo',

  // ── ReferralPage ──
  'referral.back': 'Indietro',
  'referral.loading': 'Caricamento...',
  'referral.empty': 'Nessun dato referral disponibile.',
  'referral.description': 'Questa sezione mostra l\'albero dei referral a partire da te. Mostra anche le statistiche sui bonus di un referral specifico e del suo ramo. Il nostro sistema multilivello ti permette di guadagnare il 10% dei bonus referral dei referral fatti dai tuoi referral diretti.',
  'referral.referral': 'Referral',
  'referral.bonuses': 'Bonus referral',
  'referral.subBonuses': 'Bonus sub-referral',
  'referral.level': 'livello:',
  'referral.bonusesNote': 'Bonus referral — bonus dagli acquisti dei tuoi referral diretti.',
  'referral.subBonusesNote': 'Bonus sub-referral — bonus dai referral dei tuoi referral.',
};
